export default "__VITE_ASSET__CMl2fGWc__"